/**
 * QZ Tray Integration (Jun-2026, User-Wunsch) — echtes Direkt-Drucken auf einen
 * vorkonfigurierten (Etiketten-)Drucker ohne Browser-Dialog.
 *
 * QZ Tray ist ein kostenloses, lokal installiertes Programm (https://qz.io/download/),
 * mit dem Web-Apps über einen lokalen WebSocket (wss://localhost:8181) drucken und
 * mit lokaler Hardware sprechen können. Wir laufen im UNSIGNIERTEN Modus → QZ Tray
 * fragt den Nutzer einmalig „Zulassen?". Kein Server-Zertifikat nötig (Self-Service).
 */
export const QZ_DOWNLOAD_URL = "https://qz.io/download/";
const QZ_SCRIPT = "https://cdn.jsdelivr.net/npm/qz-tray@2.2.4/qz-tray.js";

let scriptPromise = null;

function loadScript() {
    if (typeof window !== "undefined" && window.qz) return Promise.resolve(window.qz);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve, reject) => {
        const s = document.createElement("script");
        s.src = QZ_SCRIPT;
        s.async = true;
        s.onload = () => (window.qz ? resolve(window.qz) : reject(new Error("QZ Tray Bibliothek nicht verfügbar")));
        s.onerror = () => { scriptPromise = null; reject(new Error("QZ-Tray-Bibliothek konnte nicht geladen werden")); };
        document.head.appendChild(s);
    });
    return scriptPromise;
}

export async function connectQz() {
    const qz = await loadScript();
    // Unsignierter Modus → QZ Tray zeigt einen einmaligen Zulassen-Dialog.
    qz.security.setCertificatePromise((resolve) => resolve());
    qz.security.setSignaturePromise(() => (resolve) => resolve());
    if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
    }
    return qz;
}

/** Prüft, ob QZ Tray erreichbar ist (für Status-Anzeige). Wirft nicht. */
export async function probeQz() {
    try {
        const qz = await loadScript();
        if (qz.websocket.isActive()) return true;
        await qz.websocket.connect({ retries: 0, delay: 0 });
        return qz.websocket.isActive();
    } catch {
        return false;
    }
}

export async function listPrinters() {
    const qz = await connectQz();
    const printers = await qz.printers.find();
    return Array.isArray(printers) ? printers : [printers].filter(Boolean);
}

export async function getDefaultPrinter() {
    const qz = await connectQz();
    return await qz.printers.getDefault();
}

/** Druckt ein PDF (base64, ohne data:-Präfix) direkt auf den genannten Drucker. */
export async function printPdfBase64(printerName, base64) {
    const qz = await connectQz();
    const config = qz.configs.create(printerName);
    await qz.print(config, [{ type: "pixel", format: "pdf", flavor: "base64", data: base64 }]);
}
